import { useEffect, useState } from "react";
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Header = () => {
    const navigate = useNavigate();
  const [scroll, setScroll] = useState(false);
  

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  }, []);

  const goToProfile = () => {
    navigate("/join-us");
  };

  return (
    <section className={scroll ? "header scrolled" : "header"}>
      <Navbar expand="lg">
        <Container>
          <Navbar.Brand href="/">
            <img src={require("../assets/images/logo.svg").default} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto">
              <Nav.Link href="/" className="active">
                Home
              </Nav.Link>
              <Nav.Link href="/#about">About Us</Nav.Link>
              <Nav.Link href="/#features">Features</Nav.Link>
              <Nav.Link href="/#service">Services</Nav.Link>
              <Nav.Link href="/contact-us">Contact Us</Nav.Link>
              <Nav.Link href="/faqs">FAQs</Nav.Link>
            </Nav>
            <Button type="button" onClick={goToProfile}>
              Join Us
            </Button>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </section>
  );
};

export default Header;
